import React, { Component } from 'react';
import PortfolioProject from './PortfolioProject';
import './css/creative.css';

export default class Portfolio extends Component {
	render() {
		return (
			<section id="portfolio" className="bg-light-gray">
				<div className="container">
					<div className="row">
						<div className="col-lg-12 text-center">
							<h2 className="section-heading">Portfolio</h2>
							<h3 className="section-subheading text-muted">These are some of my past projects and hackathons.</h3>
						</div>
					</div>
					<div className="row">
						<PortfolioProject
							icon="img/portfolio/stevens_hackathon_ieee.png"
							iconLabel="Stevens IEEE Hackathon"
							title="Stevens IEEE Hackathon"
							desciption="Hack kitchen appliance"
							link="https://github.com/tsangjustin/CoffeeMaker" />
						<PortfolioProject
							icon="img/portfolio/startupbootcamp_fintech_hackathon.jpg"
							iconLabel="Startupbootcamp FinTech"
							title="Startupbootcamp FinTech"
							desciption="Attended Startupbootcamp FinTech Hackathon from December 9-10. Developed a robo-advisor web app that assisted elderly people in management retirement funding. Competed against 8 other teams and placed 1st for Best Use of BBVA API and won Best use Xignite API. This hackathon had technical representatives from AARP and BBVA."
							link="https://github.com/tsangjustin/hackin-the-retirement" />
						<PortfolioProject
							icon="img/portfolio/msf_hackathon.png"
							iconLabel="Doctors Without Border Hackathon - Most Impactful Team"
							title="Doctors Without Border Hackathon - Most Impactful Team"
							desciption="Developed webpage that allows user to search for Mutual Funds/ETF associated to Pfizer or GSK and take action through social media and direct e-mail to advocate dropping of prices of pneumonia shots for kids."
							link="https://www.afairshot.org/" />
						<PortfolioProject
							icon="img/portfolio/CfG.jpg"
							iconLabel="Code for Good - JP Morgan"
							title="J.P. Morgan Code for Good - 1st Place"
							desciption="Developed a mobile and web app to solve a client's problem pertaining to keeping their field workers safe when travelling"
							link="https://careers.jpmorgan.com/careers/US/en/programs/code-for-good" />
						<PortfolioProject
							icon="img/portfolio/medium_logo.png"
							iconLabel="ActionIQ Logo"
							title="Medium Blog - ActionIQ Internship"
							desciption="Read about my 8-month internship at ActionIQ and the work I did during my internship"
							link="https://medium.com/actioniq-tech/my-internship-actioniq-963136caa5e1" />
						<PortfolioProject
							icon="img/portfolio/medium_logo.png"
							iconLabel="Leetcode Valid Parentheses Blog"
							title="Blog - Leetcode Valid Parentheses"
							desciption="Read about how I tackled Leetcode problem Valid Parentheses"
							routeLink="/blog/leetcode-valid-parentheses" />
						<PortfolioProject
							icon="img/portfolio/Tetris.png"
							iconLabel="Tetris"
							title="Tetris"
							desciption="Play Tetris"
							routeLink="/tetris" />
					</div>
				</div>
			</section>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Portfolio.jsx